
import React from "react";
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTheme } from "@/components/ui/ThemeProvider";

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();

  // System icon component - used in both places for consistency
  const SystemIcon = ({ size = "h-4 w-4" }: { size?: string }) => (
    <div className={`${size} relative flex items-center justify-center`}>
      <div className="absolute inset-0 overflow-hidden rounded-full">
        <div className="flex h-full w-full">
          <div className="w-1/2 flex items-center justify-center">
            <Sun className={size === "h-4 w-4" ? "h-2.5 w-2.5" : "h-3 w-3"} />
          </div>
          <div className="w-1/2 flex items-center justify-center bg-gray-800 dark:bg-gray-200">
            <Moon className={`${size === "h-4 w-4" ? "h-2.5 w-2.5" : "h-3 w-3"} text-white dark:text-gray-800`} />
          </div>
        </div>
      </div>
    </div>
  );

  // Show system icon when theme is system, otherwise show the appropriate icon
  const getDisplayIcon = () => {
    if (theme === "system") {
      return <SystemIcon size="h-5 w-5" />;
    }
    return theme === "dark" ? (
      <Moon className="h-5 w-5" />
    ) : (
      <Sun className="h-5 w-5" />
    );
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className="rounded-full p-1 hover:bg-accent"
        >
          {getDisplayIcon()}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem onClick={() => setTheme("light")}>
          <Sun className="mr-2 h-4 w-4" />
          <span>Light</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("dark")}>
          <Moon className="mr-2 h-4 w-4" />
          <span>Dark</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("system")}>
          <div className="mr-2">
            <SystemIcon />
          </div>
          <span>System</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ThemeToggle;
